function transformUrlKeyToRegex(url: any) {
  const result = url
    .replace(/\//g, '\\/')
    .replace(/\-/g, '\\-')
    .replace(/\:[a-z0-9\-\_]+/gi, '([a-z0-9-_]+)');
  return `^${result}(\\?.*)?$`;
}

function extractParamsFromUrl(url: any, match: any) {
  const keys = url.match(/(\:\w+)/gi);
  if (keys === null) {
    return {};
  }
  const values = match.slice(1, keys.length + 1);
  return zipObject(keys, values);
}

export function zipObject(keyArray: Array<any>, dataArray: Array<any>): any {
  const finalObj: any = {};
  for (let i = 0; i < keyArray.length; i++) {
    finalObj[keyArray[i]] = dataArray[i];
  }
  return finalObj;
}

export function extractId(url: string): number {
  const matches = url.match(/\/(\d+)(?:.(?!\/\d+))+$/); // use non-capture group ?: and negative lookahead ?! to get last id
  return matches === null ? null : parseInt(matches[1], 10);
}

export function appendId(template: any, id: any) {
  const i = template.lastIndexOf('/');
  return i > -1 ? `${template.substr(0, i)}/${id}/${template.substr(i + 1)}` : `${template}${id}/`;
}

export function replaceTemplateKeys(template: any, payload: any) {
  const _vars = template.match(/\{(\w+)\}/g);
  const _result =
    _vars === null
      ? template
      : _vars.reduce((result: any, key: any) => {
          const _key = key.replace('{', '').replace('}', '');
          const _value = Object.prototype.hasOwnProperty.call(payload, _key)
            ? payload[_key]
            : Object.prototype.hasOwnProperty.call(payload, 'data') &&
              Object.prototype.hasOwnProperty.call(payload, _key)
            ? payload.data[_key]
            : null;
          return _value !== null ? result.replace(key, _value) : result;
        }, template);

  return (_vars === null || !_vars.includes('{id}')) && Object.prototype.hasOwnProperty.call(payload, 'id')
    ? appendId(_result, payload.id)
    : _result;
}

// TODO: Typescript is being a total pain
// export function matchUrl(actual_url: string, urls: Array<string>): IUrlMatch {
export function matchUrl(actual_url: string, urls: Array<string>) {
  return urls.reduce((r, url_key) => {
    const url_key_regex = transformUrlKeyToRegex(url_key);
    const match = actual_url.match(url_key_regex);
    if (match === null) {
      return r;
    }
    return {
      url_key,
      actual_url,
      params: extractParamsFromUrl(url_key, match),
    };
  }, null);
}
